import React, { useEffect, useRef, useState } from "react";

const OverallPortfolioSummaryCard = (props) => {
  const infoForm = useRef(null);
  const [overallSummaryData, setOverallSummaryData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [paymentMode, setPaymentMode] = useState(null);

  // OVERALL PORTFOLIO
  const getOverallMetricsSummary = (query, params) => {
    let data = {
      ...query,
      ...(paymentMode
        ? {
            loanPaymentMode: paymentMode,
          }
        : {}),
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: "ALL_TIME",
      };
    }

    // props.apis.apiGetOverallMetricsSummary(data, payload).then((res) => {
    //   console.log({ res });

    //   setOverallSummaryData(res);
    // });
    props.apis.apiGetOverallSummaryYesterday(data, payload).then((res) => {
      setOverallSummaryData(res);
    });
  };
  const getOverallActiveDetails = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    props.apis.apiGetOverallActiveDetails(data, payload).then((res) => {
      setOverallSummaryData((prevState) => ({
        ...prevState,
        overallActive: res,
      }));
    });
  };
  const getOverallClosedDetails = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    props.apis.apiGetOverallClosedDetails(data, payload).then((res) => {
      setOverallSummaryData((prevState) => ({
        ...prevState,
        overallClosed: res,
      }));
    });
  };
  const getOverallOverdueDetails = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    props.apis.apiGetOverallOverdueDetails(query, payload).then((res) => {
      setOverallSummaryData((prevState) => ({
        ...prevState,
        overallOverdue: res,
      }));
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handlePaymentModeChange = (value) => {
    let val = value[0]?.key || "";
    if (val === "ALL") {
      setPaymentMode(null);
    } else {
      setPaymentMode(val);
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setOverallSummaryData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    getOverallMetricsSummary(queryData, "CUSTOM");
    // getOverallActiveDetails(queryData, "CUSTOM");
    // getOverallClosedDetails(queryData, "CUSTOM");
    // getOverallOverdueDetails(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    hideInputs(inputs);
    getOverallMetricsSummary({}, "TODAY");
    // getOverallActiveDetails({}, "TODAY");
    // getOverallClosedDetails({}, "TODAY");
    // getOverallOverdueDetails({}, "TODAY");
  };

  useEffect(() => {
    // OVERALL PORTFOLIO
    getOverallMetricsSummary();
    // getOverallActiveDetails();
    // getOverallClosedDetails();
    // getOverallOverdueDetails();
  }, [timeline, paymentMode]);

  props.$setNode({
    props,
    overallSummaryData,
  });

  return (
    <>
      <div className="metrics_card_container mb-4">
        <div className="leads_detail_select_box">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-paymentmode"
            >
              <AppInputFocus
                type="select"
                name="loanPaymentMode"
                label="Product Type"
                options={_enum.REPAYMENT_TYPES}
                onChange={(...args) => handlePaymentModeChange(...args)}
                placeholder="Product Type"
              ></AppInputFocus>
            </div>
            {/* <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div> */}
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="column-start_date"
            >
              <AppInputFocus
                type="date"
                name="start_date"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="column-end_date"
            >
              <AppInputFocus
                type="date"
                name="end_date"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="column-search_btn"
            >
              <button type="submit" className="btn search_btn white_variant">
                <i className="fa fa-search"></i>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="column-reset_btn"
            >
              <button
                type="button"
                className="btn search_btn white_variant"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
              </button>
            </div>
          </AppForm>
        </div>

        <div className="row g-4 metrics_card_row">
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Overall Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.overallBookCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.overallBookAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Active Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.activeCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.activeAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCloseImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Closed Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.closedCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.closedAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overdueBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Gross Overdue</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.grossOverdueCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.grossOverdueAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 metrics_card_row">
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overdueBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>

            <div className="col_right">
              <h5 className="card-title">Part Payment</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.partPaymentCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.partPaymentAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overdueBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Net Overdue</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.netOverduePct || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.netOverdueAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <div className="amnt_icon_circle">
                <span>{overallSummaryData?.netOverduePct || 0}</span>
              </div>
            </div>
            <div className="col_right">
              <h5 className="card-title">Net Overdue %</h5>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card border-right-0">
            <div className="col_left">
              <div className="amnt_icon_circle">
                <span>{overallSummaryData?.grossOverduePct || 0}</span>
              </div>
            </div>
            <div className="col_right">
              <h5 className="card-title">Gross Overdue %</h5>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">MTD Net Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.mtdNetCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.mtdNetAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">MTD Disbursements</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.mtdDisbursedLoansCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.mtdDisbursedLoansAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">MTD Closed Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.mtdClosedCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.mtdClosedAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card border-right-0">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">MTD Gross Overdue</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.mtdOverdueCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.mtdOverdueAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">YTD Net Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.ytdNetCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.ytdNetAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">YTD Disbursements</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.ytdDisbursedLoansCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.ytdDisbursedLoansAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">YTD Closed Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.ytdClosedCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>{overallSummaryData?.ytdClosedAmount?.cur() || 0}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card border-right-0">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">YTD Gross Overdue</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>{overallSummaryData?.ytdOverdueCount || 0}</span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.ytdOverdueAmount?.cur() || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(OverallPortfolioSummaryCard);
